import { render, staticRenderFns } from "./CreateFromDraft.vue?vue&type=template&id=9e76fdce&scoped=true&"
import script from "./CreateFromDraft.vue?vue&type=script&lang=js&"
export * from "./CreateFromDraft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e76fdce",
  null
  
)

export default component.exports